import React, { ReactElement } from 'react'
import styled from 'styled-components'

const CloseButton = ({
    src,
    onClick,
    width,
    height,
}: {
    src: string
    onClick?: () => void
    width: number
    height: number
}): ReactElement => {
    return (
        <CloseIcon src={src} width={width} height={height} onClick={onClick} />
    )
}

const CloseIcon = styled.img``

export default CloseButton
